<script lang="ts">
import AbilityDisplay from '@/components/AbilityDisplay.vue'

import { useCharacterStore } from '@/stores/characterStore.ts'
import { usePerformanceStore } from '@/stores/performanceStore.ts'
import { useSpellStore } from '@/stores/spellsStore.ts'
import { useUserStore } from '@/stores/userStore.ts'
import { BButton, BFormInput, BTable } from 'bootstrap-vue-next'
import { ref, watch } from 'vue'
import { useDesignStore } from '../../../stores/designStore.ts'
import TitleWidget from '@/components/TitleWidget.vue'
import AddAbilitiesModal from './AddAbilitiesModal.vue'
import GridDisplay from '@/components/Common Building Blocks/GridDisplay.vue'
import GridAbilityDisplay from '@/components/Common Building Blocks/GridAbilityDisplay.vue'
import _ from 'lodash'

export default {
  props: ['currentStatBlock', 'updateTemp', 'isEditing'],
  emits: ['ability'],
  setup(props, context) {
    const modal = ref(false)
    const infoModal = ref(false)
    const userStore = useUserStore()
    const designStore = useDesignStore()
    const characterStore = useCharacterStore()
    const spellsStore = useSpellStore()
    const { manualPerformanceStyles } = usePerformanceStore()

    function getMedallion(group: string) {
      switch (group) {
        case 'Offensive Perks':
          return 'gi-swords-power'
        case 'Defensive Perks':
          return 'gi-heavy-helm'
        case 'Utility Perks':
          return 'gi-gear-hammer'
        case 'Supportive Perks':
          return 'gi-heart-shield'
      }
    }

    function getSortedSkills(spec) {
      return spec.skills.sort(function (a, b) {
        let aVal =
          a.skillStats.type === 'Passive'
            ? 0
            : a.skillStats.modes
              ? a.skillStats[a.skillStats.modes[0]].type === 'Passive'
                ? 0
                : 100
              : 100
        let bVal =
          b.skillStats.type === 'Passive'
            ? 0
            : b.skillStats.modes
              ? b.skillStats[b.skillStats.modes[0]].type === 'Passive'
                ? 0
                : 100
              : 100
        let ret = 0
        if (aVal > bVal) ret = 1
        else if (aVal < bVal) ret = -1

        return ret
      })
    }
    const oneToTen = [
      { value: 0, text: '0' },
      { value: 1, text: '1' },
      { value: 2, text: '2' },
      { value: 3, text: '3' },
      { value: 4, text: '4' },
      { value: 5, text: '5' },
      { value: 6, text: '6' },
      { value: 7, text: '7' },
      { value: 8, text: '8' },
      { value: 9, text: '9' },
      { value: 10, text: '10' }
    ]
    const addAbilityModal = ref(false)

    function removeAbility(name) {
      let copy = _.cloneDeep(props.currentStatBlock)
      delete copy.abilities[name]
      props.updateTemp(copy)
    }
    return {
      designStore,
      userStore,
      characterStore,

      modal,
      addAbilityModal,
      infoModal,
      manualPerformanceStyles,
      getSortedSkills,
      props,
      removeAbility,
      oneToTen
    }
  },
  components: {
    TitleWidget,
    AddAbilitiesModal,
    GridAbilityDisplay,
    GridDisplay
  }
}
</script>

<template>
  <div
    style="border-left: 2px solid; margin-left: -2px"
    :style="{ background: designStore.sidebarBacking, borderColor: designStore.secondaryTheme }"
  >
    <div
      style="
        display: flex;
        justify-content: flex-end;
        position: absolute;
        width: 90%;
        margin-top: 0.25rem;
      "
    >
      <AddAbilitiesModal
        :update-temp="updateTemp"
        :current-stat-block="currentStatBlock"
      ></AddAbilitiesModal>
    </div>

    <TitleWidget title="Abilities" style="margin-top: 0rem"></TitleWidget>
    <GridDisplay>
      <GridAbilityDisplay
        v-for="ability in currentStatBlock.abilities"
        @del="(val) => removeAbility(val)"
        :is-editing="props.isEditing"
        :key="ability.name"
        :name="ability.name"
        :rank="ability.rank"
        :medallion="ability.groupIcon"
        :description="ability.description || ''"
        :area="ability.area || ''"
        :duration="ability.duration || ''"
        :action-cost="ability.actionCost || ''"
        :resistance="ability.resistance || ''"
        :target="ability.target || ''"
        :type="ability.type || ''"
      >
      </GridAbilityDisplay>
    </GridDisplay>
  </div>
</template>

<style></style>
